export const chartColors = [
  '#7c7af0', '#3b82f6', '#f59e0b', '#06b6d4', '#ec4899', '#10b981', '#8b5cf6',
];

export const axisTickStyle = { fontSize: 10, fill: 'rgb(var(--color-text-3))' };
export const gridStroke = 'rgb(var(--color-border))';
export const legendStyle = { fontSize: 11, color: 'rgb(var(--color-text-2))' };

export function ChartTooltipContent({ active, payload, label, formatter }: any) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-panel border border-border rounded-md px-3 py-2 shadow-lg">
      <div className="text-2xs text-text-3 font-mono mb-1.5">{label}</div>
      {payload.map((p: any, i: number) => (
        <div key={p.dataKey + '-' + i} className="flex items-center gap-2 text-sm py-0.5">
          <span className="w-2 h-2 rounded-full shrink-0" style={{ background: p.color }} />
          <span className="text-text-3 text-xs">{p.name || p.dataKey}</span>
          <span className="text-text font-mono font-medium ml-auto tabular-nums">
            {formatter ? formatter(p.value) : (typeof p.value === 'number' ? p.value.toLocaleString() : p.value)}
          </span>
        </div>
      ))}
    </div>
  );
}
